T.PopupPoll = Class(
	/**
	 * @lends {T.PopupPoll#}
	 */
	{
		__NAME: 'T.PopupPoll',
		_options: [],
		_selectedOption: null,
		_errorNode: null,

		__construct(type, par) {
			par = par || {};

			this.node = mkE({
				tag: 'div'
			});

			this._mGetPoll = new DR.popuppolls.GetPoll();
			this._mGetPoll.type = type;
			let apiParams = par.apiCallParams || {};
			Object.keys(apiParams).forEach(key => {
				this._mGetPoll[key] = apiParams[key];
			});
			this._mGetPoll.onLoad = this._onGetData;
			if (par.apiCall) {
				par.apiCall.addMethod(this._mGetPoll);
			} else {
				this._mGetPoll.call();
			}
		},

		_onGetData() {
	        if (this._mGetPoll.error) {
				return;
	        }
			addClassName(this.node, 'PopupPoll');
			mkE({
				tag: 'p',
				text: this._mGetPoll.re.heading
			}).append(this.node);
			mkE({
				tag: 'h3',
				text: this._mGetPoll.re.body
			}).append(this.node);
			let options = mkE({
				tag: 'div',
				className: 'PopupPollOptions'
			}).append(this.node);
			this._mGetPoll.re.options.forEach(option => {
				let optionObject = new T.PopupPoll.Option(option, this._onChange);
				this._options.push(optionObject);
				optionObject.node.append(options);
			});
			this._button = mkE({
				tag: 'button',
				className: 'button button-pink button-large button-disabled',
				text: D.Lang.get('popup-polls.submit'),
				prop: {
					disabled: true
				},
				onclick: this._submit
			}).append(this.node);
		},

		_onChange(option) {
			if (this._selectedOption) {
				this._selectedOption.selected(false);
			}
			this._selectedOption = option;
			this._selectedOption.selected(true);
			removeClassName(this._button, 'button-disabled');
			this._button.disabled = false;
		},

		_submit() {
			if (this._errorNode) {
				this._errorNode.remove();
			}

			this._options.forEach(option => {
				option.textareaError(false)
			});

			this._mSubmitPoll = new DR.popuppolls.Respond();
			this._mSubmitPoll.pollId = this._mGetPoll.re.id;
			this._mSubmitPoll.optionId = this._selectedOption.id;
			this._mSubmitPoll.text = this._selectedOption.text;
			this._mSubmitPoll.onLoad = this._onSubmit;
			this._mSubmitPoll.onError = this._onError;
			this._mSubmitPoll.call();
		},

		_onSubmit() {
			if (this._mSubmitPoll.re.ok) {
				this._showSuccess();
			}
		},

		_showSuccess() {
			clearNode(this.node);
			T.success(D.Lang.get('popup-polls.success'), true, true).append(this.node);
			addClassName(this.node, 'success');
		},

		_onError() {
			if (this._mSubmitPoll.error === 'empty free text for option') {
				this._selectedOption.textareaError(true);
			} else {
				this._errorNode = T.error(D.Lang.get('popup-polls.error'));
				this._errorNode.prepend(this.node);
			}
		}
	},
	mkE.Base
);

T.PopupPoll.Option = Class(
	/**
	 * @lends {T.PopupPoll.Option#}
	 */
	{
		__NAME: 'T.PopupPoll.Option',

		id: 0,
		text: null,

		__construct(option, onChange) {
			this._data = option;
			this._onChangeCallback = onChange;

			this.id = this._data.id;

			this.node = mkE({
				tag: 'div',
				className: 'PopupPollOption'
			});

			this._draw();
		},

		_draw() {
			mkE({
				tag: 'button',
				text: this._data.text,
				onclick: this._onClick
			}).append(this.node);

			if (this._data.isFreeText) {
				this._textArea = new T.Form.TextArea({
					placeholder: D.Lang.get('popup-polls.comment'),
					onInput: this._onTextareaChange,
					onChange: this._onTextareaChange,
					border: true
				}).append(this.node);
			}
		},

		_onClick() {
			this._onChangeCallback(this);
		},

		_onTextareaChange() {
			this.text = this._textArea.value();
		},

		selected(isSelected) {
			if (isSelected) {
				addClassName(this.node, 'active');
			} else {
				removeClassName(this.node, 'active');
			}
		},

		textareaError(isError) {
			if (!this._textArea) {
				return;
			}
			if (isError) {
				this._textArea.error(D.Lang.get('popup-polls.text-error'));
			} else {
				this._textArea.error(null);
			}
		}
	},
	mkE.Base
);